import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {
    toogleLoad,
    setTokenSesion,
    showModalFinSesion
} from "../redux/slices/appslice";
import { getSaldosFecha, getRetirosYSaldos } from "../ws";
import { TEXT_FIN_SESION_JWT } from "../utils";
import MovimientosCmpt from "../components/movimientosCmpt";

function HistoricoCmpt() {
    const { tipo } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const appData = useSelector((state) => state.appData);
    const appDataRef = useRef(appData);
    appDataRef.current = appData;

    const [data, setData] = useState([]);
    const [titulo, setTitulo] = useState("");
    const [toReturn, setToReturn] = useState("");
    const [producto, setProducto] = useState(null);
    const [retirosYSaldos, setRetirosYSaldos] = useState(null);
    const [saldos, setSaldos] = useState([]);

    const isFetching = useRef(false);

    useEffect(() => {
        const titulosMapa = {
            'fondodeahorro': { titulo: 'Fondo de Ahorro', toReturn: '/fondodeahorro' },
            'cajadeahorro': { titulo: 'Caja de Ahorro', toReturn: '/cajadeahorro' },
            'plandepensiones': { titulo: 'Fondo de Pensiones', toReturn: '/plandepensiones' }
        };

        const config = titulosMapa[tipo];
        if (!config) {
            navigate('/');
            return;
        }

        setTitulo(config.titulo);
        setToReturn(config.toReturn);

        const fetchHistorial = async () => {
            if (isFetching.current) return;
            isFetching.current = true;
            dispatch(toogleLoad(true));

            try {
                const currentAppData = appDataRef.current;
                const saldoFecha = await getSaldosFecha(currentAppData, () => {
                    dispatch(showModalFinSesion({ texto: TEXT_FIN_SESION_JWT }));
                });

                if (saldoFecha?.JWT?.current_token) {
                    dispatch(setTokenSesion(saldoFecha.JWT.current_token));
                }

                const datosList = Array.isArray(saldoFecha?.Datos) ? saldoFecha.Datos : [];
                const prodDato = datosList.find(d =>
                    d.Producto?.[0]?.TipoCliente?.toUpperCase() === config.titulo.toUpperCase()
                );

                if (prodDato?.Producto?.[0]) {
                    const prod = prodDato.Producto[0];
                    setProducto(prod);

                    const result = await getRetirosYSaldos(appDataRef.current, prod, () => {
                        dispatch(showModalFinSesion({ texto: TEXT_FIN_SESION_JWT }));
                    });

                    if (result?.JWT?.current_token) {
                        dispatch(setTokenSesion(result.JWT.current_token));
                    }

                    if (result?.BanderaExito && result.Datos) {
                        setRetirosYSaldos(result.Datos);
                        if (Array.isArray(result.Datos.Retiros)) {
                            // Ordenar por fecha descendente (más reciente primero)
                            const retirosOrdenados = [...result.Datos.Retiros].sort((a, b) => {
                                const fechaA = String(a.FechaSolicitud || '');
                                const fechaB = String(b.FechaSolicitud || '');
                                return fechaB.localeCompare(fechaA);
                            });
                            setData(retirosOrdenados);
                        } else {
                            setData([]);
                        }
                        
                        if (Array.isArray(result.Datos.Saldos)) {
                            setSaldos(result.Datos.Saldos);
                        } else {
                            setSaldos([]);
                        }
                    } else if (result?.Mensaje && (result.Mensaje.includes("sesion") || result.Mensaje.includes("token"))) {
                        dispatch(showModalFinSesion({ texto: TEXT_FIN_SESION_JWT }));
                    }
                }
            } catch (error) {
                console.error("Error al obtener retiros y saldos:", error);
            } finally {
                dispatch(toogleLoad(false));
                isFetching.current = false;
            }
        };

        fetchHistorial();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tipo]);

    return (
        <MovimientosCmpt
            data={data}
            saldos={saldos}
            titulo={titulo === 'Fondo de Pensiones' ? 'Plan de Pensiones' : titulo}
            toReturn={toReturn}
            isWebView={false}
        />
    );
}

export default HistoricoCmpt;